
import { BaseVue } from "@newview/base-web";
import {Vue,Component, Prop, Watch } from "vue-property-decorator";
@Component({
  components: {},
})
export default class confirmClass extends BaseVue {
  control=true
  zIndex=100
  type="info"
  modalBoxId = "ModalBox_" + this.NewGuid();
  content=""
  mounted(){   
    this.zIndex = this.getMaxZIndex()
  }
  getMaxZIndex() {
		var maxZ = Math.max.apply(null, $.map($('body *'), (e:any,n)=> {
			if ($(e).css('position') != 'static' && $(e).css('display')!="none") {
				return parseInt($(e).css('z-index')) || -1;
      }else{
        return 0
      }
    }
		));
		return maxZ;
  }
  confirm(){
  }
  cancel(){
  }
}
